module.exports = __webpack_public_path__ + "img/social-media-color-blocks-hyundai.5e8e22c4.png";